import { render, staticRenderFns } from "./AddQuestionByProductCodes.vue?vue&type=template&id=7c06956c&scoped=true&"
import script from "./AddQuestionByProductCodes.vue?vue&type=script&lang=js&"
export * from "./AddQuestionByProductCodes.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionByProductCodes.vue?vue&type=style&index=0&id=7c06956c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c06956c",
  null
  
)

export default component.exports